'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Certain odds should not follow the standard rounding when converting to decimal, they are:
 *
 * @type {Object}
 */
var decimalRoundingExceptions = {
    '13/8': '2.62',
    '15/8': '2.87',
    '11/8': '2.37',
    '8/13': '1.61',
    '2/7': '1.28',
    '1/8': '1.12',
    '123/200': '1.62'
};

exports.default = decimalRoundingExceptions;